export const CategoryCardWeightInputs = [
  {
    id: '1',
    label: '1',
    value: '1',
    name: 'rating',
    toolTipText: '1 - Mentioned in room',
  },
  {
    id: '2',
    label: '2',
    value: '2',
    name: 'rating',
    toolTipText: '2 - Used at a beginner level',
  },
  {
    id: '3',
    label: '3',
    value: '3',
    name: 'rating',
    toolTipText: '3 - Used at an intermediate level',
  },
  {
    id: '4',
    label: '4',
    value: '4',
    name: 'rating',
    toolTipText: '4 - Used at an advanced level',
  },
];
